export function normalizeData(data) {
  const configFields = data.sort((a, b) => a.id - b.id);

  const modalData = configFields;

  return modalData;
}
